import * as React from 'react';
import {
	AutocompleteInput,
	BooleanInput,
	DateInput,
	Edit,
	EditProps,
	NumberInput,
	ReferenceInput,
	SelectInput,
	SimpleForm,
	TextInput
} from 'react-admin';
import { UploadImage } from '../components/UploadImage';
import { EGender, ETrainingType } from '../enums';

export const CoachEdit = (props: EditProps): React.ReactElement => {
	return (
		<Edit {...props} undoable={false}>
			<SimpleForm>
				<NumberInput step={1} source="id" label="#" disabled/>
				<TextInput step={1} source="fullName" label="FULL_NAME"/>
				<UploadImage step={1} source="profileImageUrl" label="PROFILE_IMAGE"/>
				<DateInput step={1} source="birthDate" label="BIRTH_DATE"/>
				<TextInput step={1} source="email" label="EMAIL"/>
				<NumberInput step={1} source="height" label="HEIGHT"/>
				<NumberInput step={1} source="weight" label="WEIGHT"/>
				<SelectInput step={1} source="gender" label="GENDER" choices={Object.keys(EGender).map(key => ({
					id: key,
					name: EGender[key]
				}))}/>
				<SelectInput step={1} source="trainingType" label="TRAINING_TYPE"
				             choices={Object.keys(ETrainingType).map(key => ({
					             id: key,
					             name: ETrainingType[key]
				             }))}/>
				<ReferenceInput
					step={1}
					label="COACH"
					source="coachId" reference="clients"
					alwaysOn
				>
					<AutocompleteInput optionText="fullName"/>
				</ReferenceInput>

				<ReferenceInput
					step={1}
					label="TAG"
					source="tagId" reference="tags"
					alwaysOn
				>
					<AutocompleteInput optionText="title" allo

					                   wEmpty resettable/>
				</ReferenceInput>

				<BooleanInput step={1} source="approvedByCoach" label="APPROVED_BY_COACH"/>
			</SimpleForm>
		</Edit>
	);
};
